import React from 'react';
import { Box } from '@mui/material';
import AppBrandLogo from './AppBrandLogo';

/** Drawer / header: company logo when portal branding is on and a logo URL exists; otherwise Shifty wordmark. */
export default function WorkspaceBrandLogo({
  portalBrandingEnabled,
  logoUrl,
  companyName,
  maxWidth = 280,
  sx = {},
  ...rest
}) {
  const url = typeof logoUrl === 'string' ? logoUrl.trim() : '';
  if (portalBrandingEnabled && url) {
    return (
      <Box
        component="img"
        src={url}
        alt={companyName ? `${companyName} logo` : 'Company logo'}
        sx={{
          width: '100%',
          maxWidth,
          maxHeight: 52,
          height: 'auto',
          display: 'block',
          objectFit: 'contain',
          ...sx,
        }}
        {...rest}
      />
    );
  }
  return <AppBrandLogo maxWidth={maxWidth} sx={sx} {...rest} />;
}
